const MicrositeBaseURL = 'https://signsecure-ws.unawa.io/';

export const MicrositeViewHTML = (SignSecureBaseURL: string) => `
<!DOCTYPE html>
<html lang="en">

<head>
    <meta charset="UTF-8" />
    <meta name="viewport" content="width=device-width, initial-scale=1.0" />
    <title>SignSecure</title>
    <link rel="stylesheet" href="${MicrositeBaseURL}css/normalize.css" />
    <link rel="stylesheet" href="${MicrositeBaseURL}css/styles.css" />
    <link rel="preconnect" href="https://fonts.googleapis.com" />
    <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin />
    <link href="https://fonts.googleapis.com/css2?family=IBM+Plex+Sans:ital,wght@0,100..700;1,100..700&display=swap"
        rel="stylesheet" />
    <link
        href="https://fonts.googleapis.com/css2?family=DM+Sans:ital,opsz,wght@0,9..40,100..1000;1,9..40,100..1000&family=IBM+Plex+Sans:ital,wght@0,100..700;1,100..700&display=swap"
        rel="stylesheet" />
    <script src="https://smtpjs.com/v3/smtp.js"></script>
    <link href="https://cdn.jsdelivr.net/npm/bootstrap@5.3.6/dist/css/bootstrap.min.css" rel="stylesheet"
        integrity="sha384-4Q6Gf2aSP4eDXB8Miphtr37CMZZQ5oXLH2yaXMJ2w8e2ZtHTl7GptT4jmndRuHDT" crossorigin="anonymous" />

    <script src="https://www.google.com/recaptcha/api.js" async defer></script>
</head>

<body>
    <header class="header">
        <div class="header-desktop">
            <div class="container">
                <div class="logo-container">
                    <div class="logos">
                        <a href="https://signsecure-ws.unawa.io/">
                            <img src="${MicrositeBaseURL}images/signsecure4x.png" alt="SignSecure Logo" class="logo" />
                        </a>
                        <!-- <span>BY</span>
                        <a href="https://unawa.asia/" target="_blank">
                            <img src="${MicrositeBaseURL}images/logo-unawatech-black@4x.png" alt="UNAWA Logo" class="logo-unawa" />
                        </a> -->
                    </div>
                    <div class="logo-heading">
                        <h1>
                            Sign documents online with complete security and
                            legal validity
                        </h1>
                    </div>
                </div>
                <div class="cta-button-container">
                    <a href="#pricing-plans" class="cta-button cta-button-buynow" style="visibility:hidden;">BUY NOW</a>
                    <a href="${SignSecureBaseURL}signin" target="_blank" class="cta-button">SIGN IN</a>
                </div>
            </div>
        </div>
        <div class="header-mobile">
            <div class="container header-mobile">
                <div class="logo-container">
                    <p class="logo-div">
                        <a href="https://signsecure-ws.unawa.io/">
                            <img src="${MicrositeBaseURL}images/signsecure4x.png" alt="SignSecure Logo" class="logo" />
                        </a>
                    </p>
                    <p class="logo-unawadiv">
                        <span>BY</span>
                        <a href="https://unawa.asia/" target="_blank">
                            <img src="${MicrositeBaseURL}images/logo-unawatech-black@4x.png" alt="UNAWA Logo" class="logo-unawa" />
                        </a>
                    </p>
                    <div class="cta-button-container">
                        <a href="#pricing-plans" class="cta-button cta-button-buynow" style="visibility:hidden;">BUY NOW</a>
                        <a href="${SignSecureBaseURL}signin" class="cta-button" target="_blank">SIGN IN</a>
                    </div>
                    <div class="logo-heading">
                        <h1>
                            Sign documents online with complete security and
                            legal validity
                        </h1>
                    </div>
                </div>
            </div>
        </div>
    </header>

    <main>
        <!-- For Notaries Section -->
        <!-- SECTION2 -->
        <section class="notaries-section">
            <div class="container">
                <div class="content-wrapper">
                    <div class="text-content">
                        <div class="cog-div">
                            <img src="${MicrositeBaseURL}images/Signature.png" alt="Signature Icon" class="signature-icon" />
                            <p>
                                Not all e-signatures hold up in court. Our
                                technology follows the Philippines'
                                E-Commerce Act and the Supreme Court's Rules
                                on Electronic Evidence, ensuring every
                                document is legally recognized.
                            </p>
                        </div>
                        <div class="cog-div">
                            <img src="${MicrositeBaseURL}images/shield.png" alt="Shield Icon" class="shield-icon" />
                            <p>
                                With face recognition technology, we verify
                                each signer’s identity at every step, giving
                                you confidence that the right person is
                                signing every time.
                            </p>
                        </div>
                        <a href="#pricing-plans" class="cta-button cta-button-notaries" target="_blank" style="visibility:hidden;">BUY NOW</a>
                    </div>
                    <div class="document-showcase document-showcase-notaries">
                        <img src="${MicrositeBaseURL}images/signsecureaol.png" alt="Affidavit Document"
                            class="document-image document-image-notaries" />
                    </div>
                </div>
            </div>
        </section>

        <!-- For Firms/Businesses Section -->
        <section class="businesses-section">
            <div class="container">
                <div class="content-wrapper">
                    <div class="text-content">
                        <h1>
                            How fast can you sign and secure your documents?
                        </h1>
                        <p class="businesses-note1">
                            <strong>Set up UNAWA Face Recognition (UFR)</strong>
                            <br />
                            Protect your signature with UFR, adding a layer
                            of security so only you can sign your documents.
                        </p>
                        <p class="businesses-note2">
                            <strong>Choose your signature type</strong>
                            <br />
                            Use an e-signature, a digital signature, or
                            both, depending on what works best for you.
                        </p>
                        <p class="businesses-note3">
                            <strong>Upload and sign instantly</strong>
                            <br />
                            Upload your document in PDF, DOC, DOCX, PNG, or
                            JPG, sign with a click, and you’re done.
                        </p>
                        <a href="#pricing-plans" class="cta-button cta-button-notaries" style="visibility:hidden;" target="_blank">BUY NOW</a>
                    </div>
                    <div class="document-showcase">
                        <img src="${MicrositeBaseURL}images/SignSecure-GIF.gif" alt="SignSecure Feature"
                            class="document-image document-image-businesses" />
                    </div>
                </div>
            </div>
        </section>

        <section class="features-section">
            <div class="container">
                <div class="content-wrapper">
                    <h1>Think e-signatures are just about signing?</h1>

                    <div class="feature-list">
                        <div class="feature1">
                            <h2>
                                More than just a signature, it’s secure
                                proof
                            </h2>
                            <!--<p>
                                SignSecure does more than capture your
                                signature. It lets you choose between a
                                quick e-signature or a government-backed
                                digital signature using the Philippine
                                National Public Key Infrastructure (PNPKI).
                                This adds an extra layer of protection that
                                locks your document and confirms its
                                authenticity.
                            </p>-->
                            <p>
                                SignSecure does more than capture your signature. Every signed document includes a document manifest that provides a verifiable record of the signing process, helping preserve the integrity and authenticity of every transaction.
                                <br><br>
                            </p>
                            <img src="${MicrositeBaseURL}images/signupload.png" alt="Signature Upload" />
                        </div>
                        <div class="feature2">
                            <h2>
                                Your best defense against deepfakes and
                                fraud
                            </h2>
                            <p>
                                AI-generated forgeries are getting smarter,
                                but SignSecure is built to stop them. With
                                UNAWA Face Recognition (UFR), every signer’s
                                identity is verified in real time,
                                preventing deepfake signatures before they
                                happen. No impostors, no fake documents,
                                just real, secure transactions.
                            </p>
                            <img src="${MicrositeBaseURL}images/deepfakeimg.png" alt="UFR" />
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <section class="faqs-section">
            <div class="container">
                <h3>Frequently Asked Questions (FAQs)</h3>

                <div class="accordion" id="accordionExample">
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="headingOne">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                                Is SignSecure legally recognized for
                                e-signatures in the Philippines?
                            </button>
                        </h2>
                        <div id="collapseOne" class="accordion-collapse collapse" aria-labelledby="headingOne"
                            data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                Yes! SignSecure follows the Philippines'
                                E-Commerce Act and the Supreme Court’s Rules
                                on Electronic Evidence, making e-signatures
                                legally valid.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="headingTwo">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                Do my clients or customers need an account
                                to sign documents in SignSecure?
                            </button>
                        </h2>
                        <div id="collapseTwo" class="accordion-collapse collapse" aria-labelledby="headingTwo"
                            data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                Yes, but it is free! Anyone signing a
                                document through SignSecure needs to create
                                a free account, but there are no charges for
                                signers. They can sign as many documents as
                                they need without any fees.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="headingThree">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                How does SignSecure prevent document
                                tampering or unauthorized changes?
                            </button>
                        </h2>
                        <div id="collapseThree" class="accordion-collapse collapse" aria-labelledby="headingThree"
                            data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                SignSecure locks documents the moment they
                                are signed. Every action is tracked with an
                                audit trail, and a QR code is added to
                                verify authenticity. If someone tries to
                                alter a signed document, it will be detected
                                immediately.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="headingFour">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour">
                                How does SignSecure stop deepfake signatures
                                and AI fraud?
                            </button>
                        </h2>
                        <div id="collapseFour" class="accordion-collapse collapse" aria-labelledby="headingFour"
                            data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                SignSecure uses UNAWA Face Recognition (UFR)
                                to verify each signer’s identity, preventing
                                deepfake signatures before they happen. This
                                keeps every transaction secure and
                                fraud-proof.
                            </div>
                        </div>
                    </div>
                    <div class="accordion-item">
                        <h2 class="accordion-header" id="headingFive">
                            <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse"
                                data-bs-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                What types of documents are best suited for
                                SignSecure e-signatures?
                            </button>
                        </h2>
                        <div id="collapseFive" class="accordion-collapse collapse" aria-labelledby="headingFive"
                            data-bs-parent="#accordionExample">
                            <div class="accordion-body">
                                You can use SignSecure for contracts,
                                agreements, NDAs, and other business or
                                legal documents that do not require
                                notarization. Some transactions, such as
                                real estate sales and deeds of sale, still
                                require a wet signature, but for most
                                everyday agreements, e-signatures are fully
                                valid and legally recognized.
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- Pricing Section -->
        <!--<section class="pricing-section" id="pricing-plans">
            <div class="container">
                <div class="toggle-buttons">
                    <h2>Pricing Plans</h2>
                    <div class="pricing-toggle">
                        <button id="monthlyBtn" class="active">
                            Monthly
                        </button>
                        <button id="annualBtn">Annual</button>
                    </div>
                </div>
                <div class="pricing">
                    <div class="basic">
                        <a href="${SignSecureBaseURL}checkout/pro" target="_blank"><img
                                src="${MicrositeBaseURL}images/signprofessionalmonthly.png" alt="Professional Monthly Package" /></a>
                    </div>
                    <div class="complete">
                        <a href="${SignSecureBaseURL}checkout/biz" target="_blank"><img
                                src="${MicrositeBaseURL}images/signbusinessmonthly.png" alt="Business Monthly Package" /></a>
                    </div>
                    <div class="custom">
                        <a href="https://wp.unawa.dev/#book-a-demo" target="_blank"><img
                                src="${MicrositeBaseURL}images/signcustommonthly.png" alt="Custom Monthly Package" /></a>
                    </div>
                </div>
            </div>
        </section>-->
    </main>

    <footer class="footer">
        <div class="container">
            <div class="footer-content">
                <div class="footer-left">
                    <div class="footer-logo">
                        <a href="https://unawa.asia/" target="_blank">
                            <img src="${MicrositeBaseURL}images/footer_logo.jpg" alt="UNAWA TECH" class="unawa-logo-footer" />
                        </a>
                    </div>
                    <div class="footer-address">
                        <p>
                            10th Floor, 8 Rockwell Building, Hidalgo cor Plaza Drives, 
                            Rockwell Center, Makati, Philippines
                        </p>
                        <p class="footer-email">
                            <a href="mailto:hello@unawa.asia" target="_blank">hello@unawa.asia</a>
                        </p>
                    </div>
                    <div class="social-links">
                        <a href="https://www.facebook.com/unawa.asia" class="social-link" aria-label="Facebook"
                            target="_blank"><img src="${MicrositeBaseURL}images/fb.svg" /></a>
                        <a href="https://www.instagram.com/unawa.asia/" class="social-link" aria-label="Instagram"
                            target="_blank"><img src="${MicrositeBaseURL}images/ig.svg" /></a>
                        <a href="https://youtube.com/@unawa_" class="social-link" aria-label="Youtube"
                            target="_blank"><img src="${MicrositeBaseURL}images/yt.svg" /></a>
                        <a href="https://www.linkedin.com/company/unawa/" class="social-link" aria-label="LinkedIn"
                            target="_blank"><img src="${MicrositeBaseURL}images/lin.svg" /></a>
                    </div>
                </div>
                <div class="footer-right">
                    <div class="certification">
                        <img src="${MicrositeBaseURL}images/CORSeal.png" alt="Certificate of Registration Seal" class="dpo-badge" />
                    </div>
                </div>
            </div>
            <div class="footer-bottom footer-bottom-desktop">
                <p>&copy; 2025 UNAWA. All rights reserved.</p>
                <a href="https://unawa.asia/terms-conditions" target="_blank">Terms &
                    Conditions</a>&nbsp;<span>|</span>&nbsp;<a href="https://unawa.asia/privacy-policy"
                    target="_blank">Privacy Policy</a>
            </div>
            <div class="footer-bottom footer-bottom-mobile">
                <p class="footer-bottom-copyright">
                    &copy; 2025 UNAWA. All rights reserved.
                </p>
                <p class="footer-bottom-links">
                    <a href="https://unawa.asia/terms-conditions" target="_blank">Terms &
                        Conditions</a>&nbsp;<span>|</span>&nbsp;<a href="https://unawa.asia/privacy-policy"
                        target="_blank">Privacy Policy</a>
                </p>
            </div>
        </div>
    </footer>

    <script type="text/javascript">
        var onloadCallback = function () {
            alert("grecaptcha is ready!");
        };
    </script>
    <script src="https://cdn.jsdelivr.net/npm/@emailjs/browser@3/dist/email.min.js"></script>
    <script src="https://cdn.jsdelivr.net/npm/bootstrap@5.3.6/dist/js/bootstrap.bundle.min.js"
        integrity="sha384-j1CDi7MgGQ12Z7Qab0qlWQ/Qqz24Gc6BM0thvEMVjHnfYGF0rmFCozFSxQBxwHKO"
        crossorigin="anonymous"></script>
    <script src="${MicrositeBaseURL}js/main.js"></script>
</body>

</html>
`;
